// extracted by mini-css-extract-plugin
export default {"root":"PriorityDownloadModal__root--3WRzW","text":"PriorityDownloadModal__text--1WIfH"};